import { defineNuxtPlugin } from "#app";
import { defineRule, configure } from "vee-validate";
import { localize, setLocale } from "@vee-validate/i18n";
import de from "@vee-validate/i18n/dist/locale/de.json";
import * as AllRules from "@vee-validate/rules";
export default defineNuxtPlugin(() => {
  configure({
    generateMessage: localize({
      de: {
        ...de,
        fields: {
          captcha: {
            required: "Bitte best\xE4tigen Sie, dass Sie kein Roboter sind."
          }
        }
      }
    })
  });
  setLocale("de");
  Object.keys(AllRules).forEach((rule) => {
    if (typeof AllRules[rule] !== "function")
      return;
    defineRule(rule, AllRules[rule]);
  });
});
